module.exports = __webpack_public_path__ + "assets/throttle-black.5374be37.svg";